// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ITransactionReportDestinationDto
 */
export interface ITransactionReportDestinationDto {
    /**
     * 
     * @type {string}
     * @memberof ITransactionReportDestinationDto
     */
    workflow_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ITransactionReportDestinationDto
     */
    signal_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ITransactionReportDestinationDto
     */
    sqs_request_id?: string;
}

/**
 * Check if a given object implements the ITransactionReportDestinationDto interface.
 */
export function instanceOfITransactionReportDestinationDto(value: object): value is ITransactionReportDestinationDto {
    return true;
}

export function ITransactionReportDestinationDtoFromJSON(json: any): ITransactionReportDestinationDto {
    return ITransactionReportDestinationDtoFromJSONTyped(json, false);
}

export function ITransactionReportDestinationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ITransactionReportDestinationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'workflow_id': json['workflow_id'] == null ? undefined : json['workflow_id'],
        'signal_name': json['signal_name'] == null ? undefined : json['signal_name'],
        'sqs_request_id': json['sqs_request_id'] == null ? undefined : json['sqs_request_id'],
    };
}

export function ITransactionReportDestinationDtoToJSON(json: any): ITransactionReportDestinationDto {
    return ITransactionReportDestinationDtoToJSONTyped(json, false);
}

export function ITransactionReportDestinationDtoToJSONTyped(value?: ITransactionReportDestinationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'workflow_id': value['workflow_id'],
        'signal_name': value['signal_name'],
        'sqs_request_id': value['sqs_request_id'],
    };
}

